import { useTranslation } from '@mint-lib/i18n';
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
  DialogPortal,
  DialogRoot,
  DialogTitle,
  typographyVariants,
} from '@mint-lib/tw-components';

type CurrencyManagementInfoDialogProps = {
  onClose: () => void;
  isImportHubV2: boolean;
};

export const CurrencyManagementInfoDialog = ({
  onClose,
  isImportHubV2,
}: CurrencyManagementInfoDialogProps) => {
  const { t } = useTranslation('@myn/import-hub');

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      onClose();
    }
  };

  return (
    <Dialog open onOpenChange={handleOpenChange}>
      <DialogPortal>
        <DialogOverlay />
        <DialogRoot size="m" className="max-w-[520px]">
          <DialogHeader onClose={onClose}>
            <DialogTitle>{t('Currency management')}</DialogTitle>
          </DialogHeader>
          <DialogContent className="flex flex-col gap-4">
            <DialogDescription>
              {t(
                'Only numeric values are imported. Currency symbols are ignored.',
              )}
            </DialogDescription>
            <p className={typographyVariants({ variant: 'bodyLong01' })}>
              {isImportHubV2
                ? t(
                    'The currency is determined by the target media row, or by the media plan currency for platform-level imports.',
                  )
                : t(
                    'The currency is determined by the target media row, or by the campaign currency for platform-level imports.',
                  )}
            </p>
            <p className={typographyVariants({ variant: 'bodyLong01' })}>
              {t(
                'If your file contains values in different or mismatched currencies, the system will still import the numeric values as provided. This may result in incorrect data in reports or calculations.',
              )}
            </p>
          </DialogContent>
          <DialogFooter>
            <Button size="large" onClick={onClose} data-dd-action-name="Okay">
              {t('Okay')}
            </Button>
          </DialogFooter>
        </DialogRoot>
      </DialogPortal>
    </Dialog>
  );
};
